import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { View } from "./view";
import Logo from "../../assets/images/logoAffinity.svg";
import { useNavigate } from "react-router-dom";
import { UseUserResetPassword } from "../../fnx/user/userPasswordReset";
import { position, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { useDispatch } from "react-redux";
import { userPasswordResetClearData } from "../../store/auth/actions";
export var PasswordReset = function () {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = useState(""), email = _b[0], setEmail = _b[1];
    var _c = UseUserResetPassword(trigger, email), responsePasswordReset = _c.responsePasswordReset, errorPasswordReset = _c.errorPasswordReset, loadingPasswordReset = _c.loadingPasswordReset;
    var _d = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _d[0], setSeeToast = _d[1];
    useEffect(function () {
        if (responsePasswordReset && (responsePasswordReset === null || responsePasswordReset === void 0 ? void 0 : responsePasswordReset.length) > 0) {
            setTrigger(false);
            dispatch(userPasswordResetClearData());
            navigate("/confirmPasswordReset");
        }
    }, [responsePasswordReset]);
    useEffect(function () {
        var _a, _b, _c;
        if (errorPasswordReset) {
            var error = errorPasswordReset;
            var message = "Error al restablecer contraseña";
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) !== undefined) {
                message = (_b = error.response) === null || _b === void 0 ? void 0 : _b.errors[0].message;
            }
            else {
                message = (_c = error.response) === null || _c === void 0 ? void 0 : _c.message;
            }
            setSeeToast({
                show: true,
                message: message,
                type: typeAlert.error,
            });
            setTrigger(false);
            dispatch(userPasswordResetClearData());
        }
    }, [errorPasswordReset]);
    var handleSubmit = function (dataItem) {
        setEmail(dataItem.email);
        setTrigger(true);
    };
    return (_jsxs(React.Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () {
                    setSeeToast({
                        show: false,
                        message: "",
                        type: typeAlert.success,
                    });
                }), _jsx(View, { title: "Restablecer contrase\u00F1a", subTitle: "Ingrese su correo electr\u00F3nico y enviaremos un codigo por correo para restablecer su contrase\u00F1a", emailText: "Correo electr\u00F3nico", emailPlaceHolder: "Ingresa un Usuario", logo: Logo, emailRequired: "El correo electr\u00F3nico es requerido", emailError: "Formato de correo no aceptado", emailHelperText: "Ingrese su correo electr\u00F3nico", buttonText: "Restaurar contrase\u00F1a", onSaveData: handleSubmit })] }));
};
export default PasswordReset;
